import { compose } from 'redux'

// higher-order components
import withRedux from './withRedux'
import withState from './withState'
import withMutation from './withMutation'
import withEventHandlers from './withEventHandlers'

// presentational component
import UI from './UI'

export default compose(
  withRedux, // for managing error state
  withState, // for managing logged in state
  withMutation, // for deleting the ECI
  withEventHandlers // for form actions
)(UI)
